<template>
  <div class="tab-container">
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <template v-if="table_lease_agreements_expiring_items.length">
        <app-cells><h2 class="title">Expiring</h2></app-cells>
        <table-lease-agreements-expiring
          :table-items="table_lease_agreements_expiring_items"
          :date-format="dateFormat"
          :download-file="downloadFile"
        />
      </template>
      <app-cells><h2 class="title">Agreements</h2></app-cells>
      <app-cells>
        <app-button @click.native="onOpenCreateModal(null)">Add agreement</app-button>
        <app-filters
          @change="onChangeFilter"
          v-model="status_filter"
          :filters="status_filters"
          name="filterStatus"
        />
      </app-cells>
      <table-lease-agreements
        @clickPagination="onClickPagination"
        @openCreateModal="onOpenCreateModal"
        @showDeleteModal="onShowDeleteModal"
        :table-items="table_lease_agreements_items"
        :table-preloader="table_preloader"
        :pagination="pagination"
        :date-format="dateFormat"
        :download-file="downloadFile"
      />
    </template>
    <modal
      name="create-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('create-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">{{ insurance_to_action ? 'Update' : 'Add' }} agreement</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Supplier" required>
              <app-select
                @search="onSupplierSearch"
                v-model="form.supplier"
                :options="supplier_options"
                :clearable="false"
                label="trade_name"
                placeholder="Supplier"
                :error="$v.form.supplier.$error"
              />
              <template #error>
                <div v-if="$v.form.supplier.$dirty && !$v.form.supplier.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Value" label-for="insurance_value" required>
              <app-input
                v-model.number="form.amount"
                id="insurance_value"
                placeholder="Value"
                name="insurance_value"
                type="number"
                :error="$v.form.amount.$error"
              />
              <template #error>
                <div v-if="$v.form.amount.$dirty && !$v.form.amount.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Start date" required>
              <app-date-picker
                v-model="form.start"
                placeholder="Date"
                :error="$v.form.start.$error"
              />
              <template #error>
                <div v-if="$v.form.start.$dirty && !$v.form.start.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Expire date" required>
              <app-date-picker
                v-model="form.finish"
                placeholder="Date"
                :error="$v.form.finish.$error"
              />
              <template #error>
                <div v-if="$v.form.finish.$dirty && !$v.form.finish.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Attachment" required>
              <app-uploader
                v-model="form.attachment"
                :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
                formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
                class="custom-uploader--flex"
              />
              <template #error>
                <div v-if="$v.form.attachment.$dirty && !$v.form.attachment.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">{{ insurance_to_action ? 'Update' : 'Add' }} agreement</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="delete"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete agreement
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this agreement?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteLicense" ref="deleteEvent">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import {
  deleteAdministrativePropertiesLeaseAgreements,
  getAdministrativePropertiesLeaseAgreements,
  getAdministrativeSuppliers,
  patchAdministrativePropertiesLeaseAgreements,
  postAdministrativePropertiesLeaseAgreements,
} from '@/http'
import { format, parseISO } from 'date-fns'
import debounce from 'lodash/debounce'
import axios from 'axios'
import TableLeaseAgreementsExpiring from '@/views/administrative/properties/detail/tables/TableLeaseAgreementsExpiring.vue'
import TableLeaseAgreements from '@/views/administrative/properties/detail/tables/TableLeaseAgreements'

export default {
  name: 'AdministrativePropertiesDetailLeaseAgreements',
  components: {TableLeaseAgreements, TableLeaseAgreementsExpiring},
  data() {
    return {
      page_loaded: false,
      table_lease_agreements_expiring_items: [],
      table_lease_agreements_items: [],
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
      form: {},
      status_filter: '',
      status_filters: [
        { value: '', label: 'All' },
        { value: 'false', label: 'Actual' },
        { value: 'true', label: 'Archive' },
      ],
      supplier_options: [],
      insurance_to_action: null,
    }
  },
  validations: {
    form: {
      supplier: { required },
      amount: { required },
      start: { required },
      finish: { required },
      attachment: { required },
    }
  },
  created() {
    Promise.all([
      this.fetchItemsExpiring(),
      this.fetchItemsLicenses(),
    ])
      .then(() => {
        this.page_loaded = true
      })
  },
  methods: {
    async fetchItemsExpiring() {
      const response = await getAdministrativePropertiesLeaseAgreements(this.$route.params.id, { extension_required: true })
      this.table_lease_agreements_expiring_items = response.data
    },
    async fetchItemsLicenses() {
      this.table_preloader = true
      const response = await getAdministrativePropertiesLeaseAgreements(this.$route.params.id, {
        archive: this.status_filter === 'true' ? true : this.status_filter === '' ? '' : false,
        page: this.pagination.page,
        page_size: 20,
      })
      this.table_lease_agreements_items = response.data.results
      this.pagination.pages = response.data.pages
      this.pagination.count = response.data.count
      this.table_preloader = false
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItemsLicenses()
    },
    onChangeFilter() {
      this.pagination.page = 1
      this.fetchItemsLicenses()
    },
    onOpenCreateModal(license) {
      this.insurance_to_action = license
      if (!license) {
        this.form = { type: '' }
      } else {
        this.form = {
          amount: license.amount,
          supplier: license.supplier,
          start: license.start,
          finish: license.finish,
          attachment: license.attachment,
        }
      }
      this.$v.form.$reset()
      this.$modal.show('create-modal')
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      if (!this.insurance_to_action) {
        postAdministrativePropertiesLeaseAgreements(this.$route.params.id, this.normalizeForm())
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Agreement created',
            })
            this.fetchItemsExpiring()
            this.fetchItemsLicenses()
            this.$modal.hide('create-modal')
          })
          .catch(() => {
            this.$refs.submit.preload = false
          })
      } else {
        patchAdministrativePropertiesLeaseAgreements(this.$route.params.id, this.insurance_to_action.id, this.normalizeForm())
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Agreement updated',
            })
            this.fetchItemsExpiring()
            this.fetchItemsLicenses()
            this.$modal.hide('create-modal')
          })
          .catch(() => {
            this.$refs.submit.preload = false
          })
      }
    },
    normalizeForm() {
      const normalizedForm = { ...this.form }

      normalizedForm.attachment = normalizedForm.attachment.id
      normalizedForm.supplier = normalizedForm.supplier.id

      return normalizedForm
    },
    onShowDeleteModal(id) {
      this.insurance_to_action = id
      this.$modal.show('delete')
    },
    onDeleteLicense() {
      this.$refs.deleteEvent.preload = true
      deleteAdministrativePropertiesLeaseAgreements(this.$route.params.id, this.insurance_to_action)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Agreement deleted',
          })
          this.fetchItemsExpiring()
          this.fetchItemsLicenses()
          this.$modal.hide('delete')
        })
        .catch(() => { this.$refs.deleteEvent.preload = false })
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : ''
    },
    onSupplierSearch(search, loading) {
      loading(true)
      this.searchSupplier(loading, search, this)
    },
    searchSupplier: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.supplier_options = []
      } else {
        getAdministrativeSuppliers({search}).then(response => {
          vm.supplier_options = response.data
          loading(false)
        })
      }
    }, 350),
    downloadFile(doc_obj, row) {
      axios.get(doc_obj.file, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          const extension = doc_obj.file_name.split('.').pop()
          const part_of_name = `${row.supplier.legal_name}`

          link.href = url
          link.setAttribute('download', `${part_of_name}.${extension}`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        })
    },
  }
}
</script>
